import { Share2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useShareLink } from '@app/hooks/useShareLink'
import { toast } from '@app/components/ui/Toast/toast'

/**
 * Share button component for guide pages.
 * Generates a domain-agnostic share link using the auth login flow.
 */
export const ShareButton = () => {
  const { copyShareLink } = useShareLink()

  const handleShareClick = async () => {
    try {
      await copyShareLink()
      toast({
        type: 'success',
        description: 'Share link copied to clipboard',
        position: 'top-right',
      })
    } catch {
      toast({
        type: 'error',
        description: 'Failed to copy link',
        position: 'top-right',
      })
    }
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="flex-none gap-2 h-9 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
      onClick={handleShareClick}
    >
      <Share2 className="size-4" aria-hidden="true" />
      Share
    </Button>
  )
}
